import { render, staticRenderFns } from "./UserViolations.vue?vue&type=template&id=612430ec&scoped=true&"
import script from "./UserViolations.vue?vue&type=script&lang=js&"
export * from "./UserViolations.vue?vue&type=script&lang=js&"
import style0 from "./UserViolations.vue?vue&type=style&index=0&id=612430ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612430ec",
  null
  
)

export default component.exports